import {
  EWWidgetTextProps,
  Offering,
} from "@redotech/redo-model/extended-warranty";
import { ExtendedWarrantyCheckbox as ExtendedWarrantyCheckboxComponent } from "../checkbox";

export const ExtendedWarrantyCheckbox = ({
  offerings,
  selectedOffering,
  onTileClick,
  onSeeDetailsClick,
  text,
  foundSelector,
  customCss,
}: {
  customCss?: string;
  foundSelector?: string;
  offerings: Offering[];
  selectedOffering?: Offering;
  onTileClick: (offering: Offering) => void;
  onSeeDetailsClick: () => void;
  text: EWWidgetTextProps;
}) => {
  return (
    <>
      {customCss && <style>{customCss}</style>}
      {foundSelector && <meta found-selector={foundSelector} />}
      <ExtendedWarrantyCheckboxComponent
        offerings={offerings}
        onSeeDetailsClick={onSeeDetailsClick}
        onTileClick={onTileClick}
        selectedOffering={selectedOffering}
        text={text}
      />
    </>
  );
};
